/* global process */
const def = {
  protocol: 'http',
  host: 'localhost',
  port: 8867,
  path: '/api',
}

if (process.env.NODE_ENV === 'production') {
  const { host, protocol } = window.location

  def.protocol = protocol.replace(':', '')
  def.host = host
  delete def.port
}

export default def
